<template>
  <div>
    <div class="info" v-if="!edit && !mover && !typer">
      <controls
        v-if="canEdit"
        :question="question"
        @edit="showEdit"
        @remove="remove"
        @mover="showMove"
        @typer="showTyper"
      ></controls>

      <h4 class="question-title">
        <span v-if="question.required">*</span>
        {{ question.title }}
      </h4>

      <div class="question-body">
        <div class="question-field">
          <div class="field-placeholder">Message: To see click edit.</div>
        </div>

        <div class="question-field">
          <div class="field-placeholder">
            Button Text:
            {{ question.fields[0].ondemandButtonText }}
          </div>
        </div>

        <div class="question-field">
          <div class="field-placeholder">
            Location ID:
            {{ question.fields[0].organizationLocationId }}
          </div>
        </div>
      </div>
    </div>

    <div class="edit" v-if="edit && !mover && !typer">
      <form @submit.prevent="onSubmit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control has-icons-right mt-2">
            <input
              type="text"
              :class="['input', { 'is-danger': errors['title'] }]"
              v-model="data['title']"
              name="title"
              required
            />
            <span class="icon is-small is-right" v-if="errors['title']"
              ><i class="fa fa-warning"></i
            ></span>
          </div>
          <p v-if="errors['title']" class="help is-danger">
            {{ errors["title"] }}
          </p>
        </div>

        <div class="field" :key="index" v-for="(field, index) in data.fields">
          <div class="columns">
            <div class="column">
              <div class="control field-options">
                <label class="label">Message</label>
                <quill-editor
                  :class="[{ 'is-danger': errors[`choice${index}`] }]"
                  v-model="field['ondemandMessage']"
                  :options="editorOptions"
                ></quill-editor>
                <span
                  class="icon is-small is-right"
                  v-if="errors[`choice${index}`]"
                  ><i class="fa fa-warning"></i
                ></span>
              </div>
              <div class="control field-options">
                <label class="label">Button Text</label>
                <input
                  type="text"
                  :class="['input', { 'is-danger': errors[`choice${index}`] }]"
                  v-model="field['ondemandButtonText']"
                  name="ondemand_button_text"
                  required
                />
                <span
                  class="icon is-small is-right"
                  v-if="errors[`choice${index}`]"
                  ><i class="fa fa-warning"></i
                ></span>
              </div>

              <div class="control field-options">
                <label class="label"
                  >Location ID (this can be overriden by other questions)</label
                >
                <input
                  type="text"
                  :class="['input', { 'is-danger': errors[`choice${index}`] }]"
                  v-model="field['organizationLocationId']"
                  name="organization_location_id"
                  required
                />
                <span
                  class="icon is-small is-right"
                  v-if="errors[`choice${index}`]"
                  ><i class="fa fa-warning"></i
                ></span>
              </div>
              <p v-if="errors[`choice${index}`]" class="help is-danger">
                {{ errors[`choice${index}`] }}
              </p>
            </div>
          </div>
        </div>

        <div class="field is-grouped mt2 has-text-right">
          <div class="control">
            <button
              :class="['button', 'is-primary', { 'is-loading': loading }]"
            >
              Update
            </button>
            <button
              type="button is-link"
              class="button"
              v-on:click="hideEdit()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>

    <question-move
      v-if="mover"
      :question="question"
      @hide="hideMove"
    ></question-move>
    <question-type
      v-if="typer"
      :question="question"
      @hide="hideTyper"
    ></question-type>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";
import { quillEditor } from "vue-quill-editor";
import { getToolbarOptions } from "../../helpers/editor";

export default {
  name: "ondemand",

  mixins: [baseQuestion],

  components: {
    quillEditor
  },

  data() {
    return {
      editorOptions: getToolbarOptions("Message...")
    };
  }
};
</script>

<style lang="scss" scoped></style>
